import { CrossIcon } from "@/shared/icons";
import { SoundButton } from "@/shared/ui";

type Props = {
  onClick: () => void;
};

export default function InventoryCloseButton({ onClick }: Props) {
  return (
    <SoundButton
      variant="soft"
      color="gray"
      className="w-[2.5rem] h-[2.5rem] p-0 ml-auto"
      onClick={onClick}
    >
      <CrossIcon size={16} />
    </SoundButton>
  );
}
